import $ from 'jquery';

import ThemeUtils from '../utils/ThemeUtils';

export default class ImagesWithText {
  constructor(section) {
    this.$el = $(section.el);
    this.$window = $(window);

    this.centerText(this.$el);

    this.$window.on('resize.images-with-text', ThemeUtils.debounce(() => this.centerText(this.$el), 10));
  }

  prepareRemove() {
    this.$window.off('resize.images-with-text');
  }

  centerText($container) {
    $container.css({ minHeight: '' });

    if ($container.attr('data-image-with-text-layout') !== 'background') { return; }

    const $content = $container.find('[data-feature-content]');

    const containerHeight = $container.outerHeight(true);
    const contentHeight = $content.outerHeight(true);

    if (containerHeight > contentHeight) {
      $content.css({ top: (containerHeight - contentHeight) / 2 });
    } else {
      $content.css({ top: '' });
      $container.css({ minHeight: contentHeight });
    }
  }
}
